import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/** 江西维保签到信息接口。 */
export const signService = {
  /** 分页查询江西维保签到信息。 */
  page: params => axios.get(`${iffApi}/jxxf/wb/sign`, { params })
};
